import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "UNSAFE_containerProps"];
import React from 'react';
import View from '@bubble-ui/primitive-view';
import { Separator } from '@bubble-ui/atom-separator';
import useStyleSheet from '@bubble-ui/hook-use-stylesheet';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
import { DesignContextForwardProvider, useDesignContext } from '@klarna/designtokens';
import { defaultDesignTokens } from '../defaultDesignTokens';
import { getDefaultStyleSheet } from './getDefaultStyleSheet';
var ContextMenuSeparatorComponent = _ref => {
  var {
      id,
      UNSAFE_containerProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'ContextMenuSeparator',
    props,
    useInstead: 'UNSAFE_containerProps',
    removalDate: 'v7.0.0'
  });
  var designContext = useDesignContext(defaultDesignTokens);

  // ⚠️ THIS COMPONENT SUPPORTS STYLE SHEET OVERRIDES ⚠️
  // Keep passing all props to the style sheet, even if we don't use them ourselves
  var {
    rootStyle
  } = useStyleSheet(ContextMenuSeparator, getDefaultStyleSheet, props);
  return /*#__PURE__*/React.createElement(View, _extends({
    id: id
  }, UNSAFE_containerProps, {
    style: rootStyle
  }, props), /*#__PURE__*/React.createElement(DesignContextForwardProvider, {
    context: designContext
  }, /*#__PURE__*/React.createElement(Separator, {
    colorToken: "context-menu/separator-color"
  })));
};
ContextMenuSeparatorComponent.displayName = 'ContextMenuSeparator';
export var ContextMenuSeparator = withProvisionalOverrideFromContext(ContextMenuSeparatorComponent);
//# sourceMappingURL=index.js.map